export default {
    "languages": {
        "russian": "Орыс",
        "english": "Ағылшын",
        "kazakh": "Қазақ"
    },
    "common": {
        "yes": "Иә",
        "no": "Жоқ",
        "success": "Сәтті",
        "guest": "Қонақ",
        'back': "← Артқа",
        "now": "Қазір",
        "aMinuteAgo": "бір минут бұрын",
    },
    "signin": {
        "signIn": "Кіру",
        "welcomeBack": "Қайта оралғаныңызға қуаныштымыз!",
        "introText": "iMean: әлеуметтік желілердегі сіздің ақылды көмекшіңіз.",
        "emailLabel": "Электрондық пошта мекенжайы",
        "inputPassword": "Құпиясөзді енгізіңіз",
        "passwordLabel": "Құпиясөз",
        "forgotPassword": "Құпиясөзді ұмыттыңыз ба?",
        "dontHaveAccount": "Тіркелгіңіз жоқ па?",
        "or": "немесе",
        "continue": "Жалғастыру",
        "signInEmail": "Пошта арқылы кіру",
        "signInGoogle": "Google арқылы кіру",
        "signInApple": "Apple арқылы кіру",
        "signInFacebook": "Facebook арқылы кіру",
        "signInInstagram": "Instagram арқылы кіру",
        "signInLinkedIn": "LinkedIn арқылы кіру",
        "linkFacebook": "Facebook аккаунтын байланыстырыңыз",
        "linkLinkedIn": "LinkedIn аккаунтын байланыстырыңыз",
        "linkInstagram": "Instagram аккаунтын байланыстырыңыз",
        "linkedFacebook": "Facebook аккаунты байланысты",
        "linkedInstagram": "Instagram аккаунты байланысты",
        "unlinkedLinkedIn": "LinkedIn аккаунтын ажырату",
        "unlinkedFacebook": "Facebook аккаунтын ажырату",
        "unlinkedInstagram": "Instagram аккаунтын ажырату",
        "privacy": "<offerLink>Жария оферта</offerLink> мен <privacyLink>Құпиялылық саясатының</privacyLink> шарттарын оқып шықтым, барлық талаптарды түсініп, келісемін.",
        "payment": "Төлем тәртібі",
        "contacts": "WhatsApp: +7 700 600 0001 \r\n Email: info@imean.io",
        "agreePrivacy": "“☑” белгісін басып, Жария Оферта мен Құпиялылық саясатының шарттарымен келісетіндігіңізді растаңыз.",
        "privacyTitle": "Құпиялылық саясаты",
        "offerTitle": "Жария оферта",
        "chooseLang": "Сізге ыңғайлы тілді таңдаңыз",
        "howThatWorkingBtn": "Бұл қалай жұмыс істейді?",
        "welcomeModalTitle": "Қош келдіңіз IMEAN.IO",
        "welcomeModalText": "Егер сіз мұнда бірінші рет болсаңыз және біздің қызметіміздің қалай жұмыс істейтінін білмесеңіз, біздің қосымшаның демо нұсқасын авторизациясыз сынап көру үшін \"көріңіз\" батырмасын басуға болады немесе тіркелгіңізге кіру үшін \"кіру\" батырмасын басыңыз",
        "welcomeModalOkBtn": "Көріңіз",
        "welcomeModalCancelBtn": "Кіру",
        "login": "Кіру",
        "submitSign": "Google тіркелгісі немесе электрондық пошта арқылы есептік жазбаңызға кіріңіз",
    },
    "signup": {
        "signUp": "Тіркелу",
        "fullName": "Толық аты-жөніңіз",
        "passwordRequirements": "Құпиясөз кем дегенде 8 символдан, 1 бас әріптен, 1 кіші әріптен, 1 цифрдан және 1 арнайы таңбадан тұруы керек.",
        "haveAccount": "Тіркелгіңіз бар ма?",
        "signUpGoogle": "Google арқылы тіркелу",
        "signUpApple": "Apple арқылы тіркелу",
        "signUpFacebook": "Facebook арқылы тіркелу",
        "signUpLinkedIn": "LinkedIn арқылы тіркелу",
        "lang": "Тіл",
        "submitSign": "Жүйеге кіру сұрауыңызды жіберіңіз, біз тез арада хабарласамыз.",
        "continue": "Жұмысты бастаңыз",
        "copyrights": "© 2025 IMEAN авторлық құқықтары қорғалған",
        "acceptPolicy": "Саясат пен ережелерді қабылдаңыз",
    },
    "welcome": {
        "welcome": "iMean-ге қош келдіңіз, {{username}}!",
        "howWeWork": "Біз қалай жұмыс істейміз",
        "completeSurvey": "Жеке брендті сәтті қалыптастыру үшін стратегияны әзірлеу маңызды.",
        "completeSurvey2": "Осы стратегия негізінде сіздің мақсаттарыңыз бен қалауларыңызды ескеретін контент жоспары жасалып, жарияланымдар дайындалады.",
        "proceed": "Сауалнамаға өту",
        "warning": "Стратегияның сіздің күткеніңізге барынша сәйкес болуы үшін сұрақтарға мүмкіндігінше толық жауап беру өте маңызды.",
        "warning2": "Сізбен жұмыс жасау барысында біз стратегияны біздің көзқарасымыздан сізге нақтырақ бейімдейміз.",
        "verifyEmailTitle": "Поштаңызды растаңыз",
        "verifyEmailText": "Поштаңызды растау үшін хаттан кодты енгізіңіз",
        "resendVerifyCode": "Жаңа Кодты алыңыз",
        "resendVerifyCodeSuccess": "Код сәтті жіберілді",
        "verifyEmailSuccess": "Пошта сәтті расталды",
        "verifyEmailError": "Қате! Қате код енгізілген болуы мүмкін",
    },
    "assistant": {
        "header": "Көмекші",
        "title": "Сіздің жеке көмекшіңіз",
        "getSupport": "Қолдау",
        "send": "Жіберу",
        "shortcutSend": "Жіберу: Ctrl+Enter",
        "shortcutPaste": "Қою: Ctrl+V",
        "emptyChat": "Әзірге хабарламалар жоқ",
        "pleaseWaitForResponse": "Күте тұрыңыз. Мен жауап дайындаймын...",
        "assistantInfo": "Көмекші қателік жіберуі мүмкін. Маңызды ақпаратты тексеруді ұсынамыз.",
        "helloMessage": "Сәлем!\nМен сіздің көмекшіңізбін және әртүрлі жағдайларда көмектесуге дайынмын: электрондық хат дайындау немесе оған жауап беру,\nсоңғы жаңалықтармен бөлісу, әзіл айту немесе аударма жасау. Мен сізге жұмыста, бизнесте және басқа да көптеген мәселелерде қолдау көрсетуге дайынмын. Сізге қалай көмектесе аламын?",
        "textToGeneratePostFromAssistantMessage": "Минималды өзгерістермен осы пост негізінде жарияланым жасаңыз",
        "createPostFromThisMessageBtn": "Осы хабарлама негізінде хабарлама жасаңыз",
        "createsSeriesPostsFromThisMessageBtn": "Осы хабарламаның контекстіне негізделген хабарламалар сериясын жасаңыз",
        "addNewPostToSeries": "Серияға жаңа пост қосу",
        "notEnoughPosts": "Серия жасау үшін жазбалар жетіспейді",
        "deleteSeriesElement": "Сіз шынымен серияның осы элементін жойғыңыз келе ме?",
        "createPostSuccess": "Пост №{{count}} сәтті жасалды!",
        "createPostError": "№{{Count}} жазбасын жасау кезіндегі қате",
        "postTitlePrefix": "Сериядан Пост №",
        "chatSettingsTitle": "Чат параметрлері",
        "useYourFile": "Файлыңызды пайдаланыңыз",
        "useEmployeeFile": "Қызметкер файлын пайдалану",
        "useInternetSearch": "Интернеттен іздеуді қолданыңыз",
        "useInternetSearchingConfirm": "Ассистент арқылы посттарды жариялау үшін, ассистенттің баптауларында интернетті қолдану өшірілгеніне көз жеткізіңіз.",
        "assistantWarningInfo": "Бұл функцияға кіру үшін файлды жүктеу керек",
        "assistantMakeQuestionsPopoverTitleTrue": "Жетекші сұрақтар жасаңыз (қосылған)",
        "assistantMakeQuestionsPopoverTitleFalse": "Жетекші сұрақтар жасаңыз (өшірулі)",
        "assistantMakeQuestionsPopoverContent": "Көмекші сізге тақырып бойынша жетекші сұрақтар жасайтынын қосыңыз.",
        "assistantQuickFilePopoverTitleEmpty": "Жылдам файл",
        "assistantQuickFilePopoverTitle": "Тіркелген файл",
        "assistantQuickFilePopoverInfo": "Неғұрлым сәйкес жауап немесе файл мазмұнын талдау үшін хабарламаңызға бір жылдам файлды тіркей аласыз.",
        "assistantSettingsInstructionTitle": "Көмекшіні үйретудің сынақ режимі.",
        "seriesPostsInstruction": "Енді сіз бір тақырыпқа арналған өзара байланысты посттар сериясын жасай аласыз. Әр пост алдыңғысының логикалық жалғасы болып, біртұтас құрылымды қалыптастырады.\n" +
            "Генерациядан кейін әр постты бәрі көңіліңізден шыққанша ассистенттің көмегімен өңдей аласыз. \n" +
            "Барлығы дайын болғанда — серияны «Пост жариялау» бөліміне жіберіп, әрі қарай жұмыс істеуге және жоспарлауға болады.",
        "seriesPostsFromArrayInstruction": "Енді Сіз Ассистент арқылы тікелей жарияланымдар жасай аласыз. Ұнаған мәтінді — жеке пост болсын немесе бірнеше бір-бірімен байланысқан жазбалар сериясы болсын — бірден жариялауға жіберуге болады.",
        "assistantSettingsInstructionContent": "Көмекшімен өзара әрекеттесу үшін оған ақпарат беріңіз. (Бұл режимге қосымша, жақын арада көмекшінің қосымша өте керемет мүмкіндіктері пайда болады).",
        "assistantFilesInstructionTitle": "Көмекшіні пайдалану жөніндегі Нұсқаулық",
        "assistantFilesInstructionContent": `Сіз оны зерттейтін және сізбен қарым-қатынас кезінде пайдаланатын көмекшіге ақпарат бере аласыз. Ол үшін келесі қадамдарды орындаңыз:
1. Файлды Word форматында дайындаңыз (.doc немесе .DOCX), ассистент ескеруі керек ақпаратты қамтиды.
2. Егер сіз бұрыннан бар мәліметтерге жаңа деректер қосқыңыз келсе, бұрын қосылған барлық ақпаратты сақтай отырып, сол файлға жаңа мәліметтер енгізіңіз.
3. Файлды қызметтің тиісті бөлімі арқылы жүктеңіз.
Ақпаратты өңдегеннен кейін көмекші оны жауаптары мен ұсыныстарында қолдана бастайды.`,
        "assistantFilesInstructionEmployeeContent": "Сіз ассистентпен өзара әрекеттесу кезінде пайдаланылатын ақпаратты ұсына аласыз.\n" +
            "Мұны жасау үшін келесі қадамдарды орындаңыз:\n" +
            " 1. Ассистент ескеруі керек ақпаратты қамтитын Word (.doc немесе .docx) форматындағы файлды дайындаңыз.\n" +
            " 2. Егер сіз бар мәліметтерге жаңаларын қосуды қаласаңыз, жаңартылған ақпаратпен файлды жүктеңіз.",
        "assistantInternetSearchInstructionTitle": "Ассистенттегі интернет-сұраныстарды пайдалану нұсқаулығы",
        "assistantInternetSearchInstructionContent": "Енді сіз ассистентте интернет-сұраныстарды пайдаланып, желіден өзекті ақпарат ала аласыз.\n" +
            "\n" +
            "Интернет-сұраныстарды қалай қосуға болады?\n" +
            " 1.  1. Ассистент баптауларында “Интернетті пайдалану” белгісін қосыңыз.\n" +
            " 2. Белгіні қосқаннан кейін, ағымдағы сессиядағы барлық сауалдар жауап дайындау үшін интернетті пайдаланатын болады.\n" +
            "Маңызды шектеулер\n" +
            " 1. Интернетке қолжетімділік тек ағымдағы сессия кезінде белсенді болады. Қызметке келесі кіргенде белгіні қайта қосу қажет.\n" +
            " 2. Жауап беру уақыты сәл ұзаруы мүмкін, өйткені ақпарат нақты уақыт режимінде жүктеледі.",
        "uploadFile": "Файлды жүктеу",
        "uploadNewFile": "Файлды жаңарту",
        "yourHaveFile": "Сізде жүктелген файл бар.",
        "confirm": "Растау",
        "fileUploadSuccess": "Сәтті жүктелді!",
        "post": {
            "postTitle": "Пост",
            "generateImageLimitExceeded": "Осы постқа сурет генерация шегі асты (3 талпыныс)."
        },
        "postThemePlaceholder": "Пост тақырыбын енгізіңіз",
        "postContentPlaceholder": "Пост мәтінін енгізіңіз",
        "postHashtagsPlaceholder": "Пост үшін хэштегтерді енгізіңіз",
        "required": "Міндетті",
        "getLeadingQuestions": "Жетекші сұрақтар алыңыз",
        "waitLeadingQuestions": "Сұрақтар дайындау",
        "seeLeadingQuestions": "Жетекші сұрақтарды ашыңыз",
        "yourAnswerFromQuestionLabel": "Сіздің сұрағыңызға жауап",
        "moveLeadingQuestionsToChatMessage": "Сұрақтарды чатқа жіберіңіз",
        "moveLeadingAnswersToChatMessage": "Жауаптарды чатқа жіберіңіз",
        "leadingQAPrompt1": "{{count}}-сұрақ: «{{question}}»\nжәне пайдаланушының жауабы: «{{answer}}»\n\n",
        "leadingQAPrompt2": "Пост тақырыбына қатысты қосымша сұрақтарға пайдаланушының жауабын ескере отырып, №{{PostId}} «{{postContext}}» постына толықтырулар енгіз:\n{{prompt}}\nҚалған посттарға өзгеріс енгізбе, барлық посттарды жауапта толық көрсет.",
        "startRecording": "Жазуды бастаңыз",
        "stopRecording": "Жазуды тоқтату",
        "getAnswer": "Жауап алыңыз",
        "waitAnswer": "Жауап дайындау",
        "reGetAnswer": "Жаңа жауап алыңыз",
        "yourMessage": "Сіздің хабарламаңыз",
        "answerWithNumber": "Жауап {{count}}: {{answer}}",
        "warningInternetSearchModalTitle": "Назар аударыңыз!",
        "warningInternetSearchModalText": "Қазіргі уақытта ассистенттің баптауларында интернеттен іздеу функциясы қосулы. Егер Сіз посттар генерациясын пайдалануды жоспарлап отырсаңыз, ассистенттің дұрыс жұмыс істеуін қамтамасыз ету үшін бұл функцияны уақытша өшіруді ұсынамыз.",
        "warningInternetSearchModalSkipBtn": "Іздеуді өшіру",
        "warningInternetSearchModalAgreeBtn": "Өзгеріссіз жалғастыру",
        "sendChatMessageErrorText": "Алдыңғы сұраныс әлі өңделіп жатыр. Күте тұруыңызды өтінеміз. Егер мәселе шешілмесе, Техникалық қолдау қызметіне хабарласуыңызды сұраймыз.",
    },
    "system_messages": {
        "request_for_editing_post": "⌬ Постты өңдеу туралы сұрау",
        "request_for_editing_post_with_info": "⌬ Жауаптарды ескере отырып, №{{postNumber}} оразаны қалпына келтіру:\n\n{{text}}",
    },
    "profile": {
        "shareLocationExplanation": "Жоспарлауды жақсарту үшін шамамен орналасқан жерді (қала/ел) бөлісіңіз.",
        "socialConnectionsTitle": "Әлеуметтік байланыстар",
        "hintConnectLinkedIn": "Жариялау үшін LinkedIn қосыңыз",
        "hintConnectFacebook": "Facebook бизнес парақшаңызды қосыңыз",
        "hintConnectInstagram": "Instagram Business есептік жазбаңызды қосыңыз",
        "hintFacebookHelp": "Жариялау үшін Facebook бизнес бетін қосыңыз. Төмендегі нұсқаулықтағы қадамдарды орындаңыз.",
        "hintInstagramHelp": "Instagram парақшаңыздың Facebook бетіне қосылған іскери тіркелгі екеніне көз жеткізіңіз.",
        "unlinkLinkedinConfrim": "Сіз шынымен LinkedIn есептік жазбаңызды шешкіңіз келе ме?",
        "unlinkFacebookConfrim": "Сіз шынымен Facebook есептік жазбаңызды шешкіңіз келе ме?",
        "unlinkInstagramConfrim": "Сіз шынымен Instagram есептік жазбаңызды шешкіңіз келе ме?",
        "openFBDocsTitle": "Қолдану нұсқаулығын ашу",
        "noPagesFB": "Facebook беттері жоқ",
        "noPagesLinkedIn": "LinkedIn-де беттер жоқ",
        "cancelDelete": "Жоюды болдырмау",
        "accountWillBeDeleted": "Сіздің есептік жазбаңыз жойылады",
        "recoverAccount": "Жоюды болдырмау",
        "removeAccountBtn": "Есептік жазбаны жою",
        "yesRemoveAccount": "Иә, жою.",
        "notRemoveAccount": "Жоқ, жоймау",
        "removeAccountTitle": "Сіз есептік жазбаны шынымен жойғыңыз келе ме?",
        "removingApproved": "Есептік жазбаны жою туралы сұрау сәтті жіберілді!",
        "recoverApproved": "Есептік жазбаны жоюды болдырмау туралы сұрау сәтті жіберілді!",
        "accountActionWait": "Күтіңіз...",
        "removeAccountDescription": "Осы түймені басу арқылы сіз 14 күннен кейін деректеріңіздің мәңгілікке жойылатынын растайсыз. Осы мерзім өткен соң есептік жазбаны қалпына келтіру мүмкін болмайды.",
        "emptyReferrals": "Сіз әлі ешкімді шақырған жоқсыз!",
        "status-accepted": "Шақырылды",
        "status-pending": "Күтілуде...",
        "status-gifted": "Сыйақы алынды",
        "status-taken": "Шақырудан бас тартылды",
        "close": "Жабу",
        "yourReferrals": "Сіздің жолдауларыңыз",
        "reInvite": "Қайта жіберу",
        "inviteSent": "{{email}} электрондық поштасына шақыру жіберілді",
        "inviteError": "Шақыру жіберу кезінде қате орын алды. Бұл пайдаланушының бұрыннан тіркелгеніне байланысты болуы мүмкін.",
        "header": "Профиль",
        "assistDescription": "Жетілдірілген көмекшіден соңғы жаңалықтар мен кеңестерді алыңыз",
        "endSubscriptionDate": "Жазылым мерзімі аяқталады:",
        "endFreeSubscriptionDate": "Сынақ мерзімі аяқталады:",
        "buySubscription": "Жазылымды сатып алу",
        "subscriptionManagement": "Жазылымды басқару",
        "upgradeSubscription": "Жоспарды жаңарту",
        "extendSubscription": "Жазылымды ұзарту",
        "cancelSubscription": "Жазылымнан бас тарту",
        "comingSoon": "Көп ұзамай...",
        "soon": "Жақында...",
        "name": "Аты",
        "position": "Лауазымы",
        "industry": "Қызмет саласы",
        "login": "Кіру",
        "subscription": "Жазылым мерзімі",
        "no": "Жоқ",
        "yes": "Иә",
        "lang": "Тіл ұрпақ",
        "gender": "Гендер",
        "male": "Ер адам",
        "female": "Әйел",
        "other": "Басқа",
        "timeZone": "Уақыт белдеуі",
        "organizationTitle": "Ұйымдастыру",
        "buttons": {
            "share": "Бөлісу",
            "reshare": "Қайта бөлісу",
            "link": "Сілтеме",
            "unlink": "Байланысты жою",
            "pages": "Беттер",
            "help": "Көмек",
        },
        "linkAccount": "Есептік жазбаны байланыстыру",
        "linkedInError": "Есептік жазбаны қайта тағайындау",
        "inviteFriend": "Досыңызды шақырыңыз:",
        "invite": "Шақыру",
        "timeZoneModalTitle": "Уақыт белдеулері",
        "inviteModalTitle": "Досыңызды шақырыңыз және жарты ай тегін алыңыз!",
        "timeZoneModalText": `
        Біз сіздің ыңғайлылығыңыз үшін уақыт белдеуін (мысалы, UTC+5) таңдауды енгіздік, бұл жазбаларыңыздың кестесін нақтылауға мүмкіндік береді. Бұл қалаған аймақтағы аудиторияңызды жақсырақ нысанаға алуға және барынша қамтуға көмектеседі.
        <br>
        <b>LinkedIn-ге жазба жариялау үшін ұсынылатын уақыттар:</b>
        \t•\tДүйсенбі: таңғы 8:00-ден 10:00-ге дейін
        \t•\tСейсенбі: таңғы 9:00-ден 12:00-ге дейін
        \t•\tСәрсенбі: таңғы 10:00-ден 12:00-ге дейін
        \t•\tБейсенбі: таңғы 9:00-ден 11:00-ге дейін
        \t•\tЖұма: таңғы 9:00-ден 12:00-ге дейін
        <br>
        <b>Қолдану мысалы:</b>
        Егер сіз Қазақстанда (UTC+5) болсаңыз және АҚШ-тағы (мысалы, Нью-Йорк, UTC-5) аудиторияға мазмұн жариялағыңыз келсе, сәйкес уақыт белдеуін таңдаңыз. Бұл жазбаларыңыз Нью-Йорк уақытында таңғы 9:00-де көрінетініне кепілдік береді.
        <br>
        <b>Негізгі елдер мен олардың UTC айырмашылықтары:</b>
        <b>Азия</b>
        <br>
        \t•\tҚазақстан (Алматы): UTC+5
        \t•\tҚытай (Бейжің): UTC+8
        \t•\tҮндістан (Нью-Дели): UTC+5:30
        \t•\tЖапония (Токио): UTC+9
        \t•\tОңтүстік Корея (Сеул): UTC+9
        \t•\tИндонезия (Джакарта): UTC+7
        <b>Африка</b>
        \t•\tОңтүстік Африка (Йоханнесбург): UTC+2
        \t•\tЕгипет (Каир): UTC+2
        \t•\tНигерия (Лагос): UTC+1
        \t•\tКения (Найроби): UTC+3
        \t•\tМарокко (Рабат): UTC+0
        <b>Латын Америкасы</b>
        \t•\tБразилия (Сан-Паулу): UTC-3
        \t•\tАргентина (Буэнос-Айрес): UTC-3
        \t•\tМексика (Мехико): UTC-6
        \t•\tКолумбия (Богота): UTC-5
        \t•\tЧили (Сантьяго): UTC-3
        <b>Еуропа</b>
        \t•\tҰлыбритания (Лондон): UTC+0
        \t•\tГермания (Берлин): UTC+1
        \t•\tФранция (Париж): UTC+1
        \t•\tИталия (Рим): UTC+1
        \t•\tИспания (Мадрид): UTC+1
        <b>Солтүстік Америка</b>
        \t•\tАҚШ (Нью-Йорк, Шығыс уақыты): UTC-5
        \t•\tАҚШ (Лос-Анджелес, Тынық мұхиты уақыты): UTC-8
        \t•\tКанада (Торонто): UTC-5
        \t•\tКанада (Ванкувер): UTC-8
        <b>Қосымша ескертулер:</b>
        Кейбір елдерде бірнеше уақыт белдеуі бар екенін ескеріңіз. Егер сіздің мақсатты аудиторияңыз басқа елде болса, ең жақсы жариялау уақыттарын анықтау үшін тиісті UTC айырмашылығын тексеруді ұсынамыз.
        Жергілікті уақыттарды timeanddate.com сияқты құралдарды пайдаланып тексеруге болады.
        <br>
        Уақыт белдеуіңізді орнатыңыз және аудиторияңыздың назарын барынша арттырыңыз! 😊
    `,
        "inviteModalText": `
        Біздің қызметімізді тегін қосымша күндермен қолданғыңыз келе ме?<br>
        Жай ғана досыңызды шақырыңыз! Мұнда қалай жұмыс істейді:
        <br>
        <ol>
        <li><b>1. Байланыс деректерін бөлісіңіз:</b> Қызметіміз сіздің досыңызға қызықты болуы мүмкін деп ойласаңыз, оның электрондық поштасын беріңіз.</li>
        <li><b>2. Біз электрондық пошта жібереміз:</b> Біз досыңызға электрондық пошта жібереміз (сізді көшірмеде қалдырамыз), қызметімізді таныстырамыз және сіздің шақырғаныңызды хабарлаймыз. Бұл досыңыздың оның спам немесе алаяқтық емес екенін түсінуін қамтамасыз етеді.</li>
        <li><b>3. Жарты ай тегін алыңыз:</b> Егер досыңыз тіркеліп, ақылы жоспарға жазылса, сіз автоматты түрде досыңыз таңдаған жоспарға 15 күн тегін аласыз.</li>
        <li><b>4. Сіздің досыңыз да пайда көреді:</b> Досыңыз да қызметімізді бірінші ай бойы пайдалану үшін <b>30% жеңілдік</b> алады. Бұл барлығына пайдалы!</li>
        </ol>
        <br>
        Егер сізде сұрақтар болса, бізбен <a class='text-purple-800' href="mailto:info@imean.io">info@imean.io</a> электрондық поштасы арқылы байланысыңыз — біз көмектесуге дайынбыз!
    `,
        "shareGeoDataButtonTitle": "Орынды бөлісу",
        "reShareGeoDataButtonTitle": "Орынды жаңарту",
        "sharedGeoDataSuccess": "Сіз i серверде орналасқан жеріңізді сәтті жаңарттыңыз IMEAN.IO",
        "sharedGeoDataError": "I сервердегі орынды жаңарту кезінде қате пайда болды IMEAN.IO",
        "selectFacebookPage": "Facebook бетін таңдаңыз",
        "selectLinkedInPage": "LinkedIn бетін таңдаңыз",
        "helpForFacebook": "Facebook-ке көмек",
        "fbPagesInfoLinking": "Facebook-тің тіркелгіңізді біздің қызметімізбен байланыстыру үшін, сізде жеке парақша ғана  емес, Facebook парақшасы бар екеніне көз жеткізіңіз." +
            "<br/>" +
            "<br/>" +
            "Парақшаны қалай жасау керектігі туралы ақпаратты басты терезедегі «Пайдалы кеңестер» бөлімінен таба аласыз.",
        "helpForInstagram": "Instagram-ға көмек",
        "instInfoLinking": "Instagram тіркелгіңізді біздің қызметімізбен байланыстыру үшін, сізде Instagram бизнес-аккаунты бар екеніне көз жеткізіңіз." +
            "<br/>\n" +
            "<br/>\n" +
            "Бизнес-аккаунтты қалай жасау керектігі туралы ақпаратты басты терезедегі «Пайдалы кеңестер» бөлімінен таба аласыз.",
    },
    "subscriptionPlans": {
        "header": "Тарифтер",
        "Strategy": "Стратегия",
        "ContentPlan": "Контент жоспарлары",
        "LeadingQuestions": "Негізгі сұрақтар",
        "Post": "Посттар",
        "Theme": "Тақырыптар",
        "PostImages": "Пост суреттері",
        "free": "Тегін",
        "paid": "Премиум",
        "assistant": "Кеңейтілген Ассистент",
        "infoButton": "Функционал сипаттамасы",
        "promoCodeTitle": "Промо-код",
        "havePromoCode": "Промо-код бар ма?",
        "promoCodeError": "Қате промо-код немесе акция мерзімі аяқталды",
        "modalTitle": "IMEAN.IO қызметінің функционалы:",
        "modalText": `
            iMean LinkedIn, Facebook, Instagram желісінде жасанды интеллект арқылы посттар құруды жеңілдетіп және тиімді етеді. Қызметіміз келесілерді ұсынады:
            
             <b>• Жасанды интеллект арқылы пост жасау:</b>
            Қызметіміз кәсіби мақсаттарыңызға және жеке стиліңізге сай контент жасайтын алгоритмдерді пайдаланады. Бұл контент аудиторияңыз бен сіздің салаларыңыздың негізгі тақырыптарына сәйкес келеді, сізді бәсекелестерден ерекшелендіреді және жеке брендіңізді қалыптастырады.
            
             <b>• Бір сәтте немесе жоспар бойынша жариялау:</b>
            Посттарды бірден жариялауға немесе ыңғайлы уақытта жоспарлауға мүмкіндік береді. Жоспарлы жариялау платформаның белсенділігін сақтауға және аудиторияға ең тиімді уақытта жетуге көмектеседі.
            
             <b>• Ассистент:</b>
            Интеллектуалды ассистент сұрақтарыңызға жауап беруге, пост идеяларын жасауға, мәтіндерді аударуға, іскерлік хаттар құрастыруға және аудиториямен өзара әрекеттесу стратегияларын ұсынуға дайын. Сіз ассистентке пост жазып, оны бірден LinkedIn, Facebook, Instagram жариялауды сұрай аласыз, бұл уақытыңызды үнемдейді.
            
             <b>• Дауыстық енгізу:</b>
            Терудің қажеті жоқ — тек сөйлеңіз, қызметіміз сөздеріңізді мәтінге аударады. Бұл мүмкіндікті уақыт тапшылығы кезінде немесе идеяңызды жылдам жазып алу үшін пайдалануға болады.
        `,
        "submit": "ОК",
        "unlimitedRate": "Шексіз функционал",
        "assistantRate": "Шексіз функционал + жеке жасанды интеллект ассистенті",
        "freeRate": "Тегін сынақ кезеңі 14 күнге",
        "active": "Белсенді",
        "offerExpire": "Ұсыныс аяқталады",
        "offerOver": "Ұсыныс аяқталды",
        "subscribeExpired": "Жазылу мерзімі аяқталды",
        "subscribeExtended": "Жазылым сәтті ұзартылды!",
        "rememberMyCard": "Картаны есте сақтаңыз",
        "rememberMyCardPopoverTitle": "Төлем жасау  жөнiнде пайдаланушыларға арналған кеңес",
        "rememberMyCardPopoverText": "Сіздің қолайлылығыңыз үшін чекбокс таңдауын белгілеп, картаны сақтай аласыз және келесі төлемдерде оны қайта енгізудің қажеті болмайды. Біз сіздің картаңыздың деректерін сақтамаймыз және өңдемейміз — бұл процесті төлемдерді қауіпсіз өңдеуді қамтамасыз ететін FreedomPay халықаралық төлем платформасы жүзеге асырады.\n" +
            "\n" +
            "Егер қолыңызда карта болмаса, Apple Pay, Google Pay немесе Samsung Pay арқылы төлем жасай аласыз. Бұл жағдайда картаны сақтау үшін  белгі  таңдаудың қажеті жоқ.",
        "removeMyCardBtn": "Картаны жою",
        "cardDeleted": "Карта сәтті жойылды!",
        "cardDeleteError": "Картаны жою кезінде сервер қатесі!",
        "confirmDeleteCard": "Сіз шынымен төлем картаңызды жойғыңыз келе ме?",
        "confirmExtendSubscribe": "Жазылымды жаңартуды растаңыз",
    },
    "publicationCalendar": {
        "loading": "Деректер жүктелуде...",
        "today": "Бүгін",
        "navigationTitles": {
            "past60": "-2ай",
            "past30": "-1ай",
            "past10": "-10күн.",
            "past7": "-1ап.",
            "past5": "-5күн.",
            "past3": "-3күн.",
            "past1": "-1күн.",
            "future1": "+1күн.",
            "future3": "+3күн.",
            "future5": "+5күн.",
            "future7": "+1ап.",
            "future10": "+10күн.",
            "future30": "+1ай",
            "future60": "+2ай",
        },
        "postStatuses": {
            "published": "Пост сәтті жарияланды!",
            "error": "Жариялау қатесі:",
            "pending": "Жариялауды күту...",
        },
        "postTypes": {
            "personal": "(жеке)",
            "quickPersonal": "Жылдам пост",
            "planPersonal": "Контент-жоспардан пост",
            "quickEmployee": "Жылдам пост (қызметкер)",
            "planEmployee": "Контент-жоспардан пост (қызметкер)",
            "other": "Басқа түрі"
        },
        "goToPost": "Постқа өту",
        "legend": "Түсіндірме",
        "contentTypes": {
            "contentPlan": "Контент-жоспардан пост",
            "quickPost": "Жылдам пост"
        },
        "noPosts": "Посттар жоқ",
        "filters": {
            "byUser": "Пайдаланушы бойынша сүзгі:",
            "selectUser": "Пайдаланушыны таңдаңыз",
            "allUsers": "Барлық пайдаланушылар"
        },
        "toolbar": {
            "today": "Бүгін",
            "past": "Өткен:",
            "future": "Болашақ:",
            "view": "Көрініс:",
            "viewOptions": {
                "day": "Күн",
                "week": "Апта",
                "month": "Ай",
                "year": "Жыл",
                "custom": "Еркін"
            }
        },
        "messages": {
            "loadingPosts": "Посттар жүктелуде…",
            "noPosts": "Посттар жоқ"
        },
        "legendLabels": {
            "quickPersonal": "Жылдам пост (жеке)",
            "plannedPersonal": "Контент-жоспардан пост (жеке)",
            "quickEmployee": "Жылдам пост (қызметкер)",
            "plannedEmployee": "Контент-жоспардан пост (қызметкер)"
        }

    },
    "survey": {
        "survey": "Сауалнама",
        "recording": "Дауыс жазылып жатыр... Тоқтату үшін басыңыз",
        "type": "немесе жауабыңызды осында теріңіз...",
        "wait": "Жауаптарыңыз сақталып, ақпарат жасалуда. Біраз күте тұрыңыз",
        "clear": "Тазалау",
        "submit": "Жіберу",
        "tapToStart": "Жауабыңызды айту үшін басыңыз",

        "title": "Контент құру үшін ақпаратты толтырыңыз",

        "inputLabelName": "Сіздің атыңыз?",
        "inputPlaceholderName": "Атыңызды енгізіңіз",
        "inputInfoName": "Бұл ат контентте қолданылады",

        "inputLabelIndustry": "Сала",
        "inputPlaceholderIndustry": "Сіздің салаңыз",
        "inputInfoIndustry": "Егер сіздің салаңыз тізімде болмаса, оны қолмен енгізіңіз",

        "inputLabelPosition": "Лауазым",
        "inputPlaceholderPosition": "Сіздің лауазымыңыз",
        "inputInfoPosition": "Егер сіздің лауазымыңыз тізімде болмаса, оны қолмен енгізіңіз",

        "textLabelWorkExperienceAndSkills": "Жұмыс тәжірибесі мен негізгі дағдылар",
        "textPlaceholderWorkExperienceAndSkills": "Жұмыс тәжірибеңіз, негізгі дағдыларыңыз бен біліктілігіңіз туралы қысқаша сипаттама және сіз мақтанатын жобалар.",

        "textLabelPersonalityHobby": "Жеке қызығушылықтар мен хоббилер",
        "textPlaceholderPersonalityHobby": "Посттарды шынайырақ етіп көрсету үшін қызығушылықтарыңыз бен хоббилеріңіз туралы ақпарат.",

        "textLabelSocialActivity": "Әлеуметтік белсенділік және қоғамдағы қатысу",
        "textPlaceholderSocialActivity": "Сіз қатысатын топтар немесе қауымдастықтар (мысалы, кәсіподақтар, волонтерлік, кәсіби топтар).",

        "textLabelShortGoals": "Қысқа мерзімді мансаптық мақсаттар (1-2 жыл)",
        "textPlaceholderShortGoals": "Қысқа мерзімде жетуді қалайтын кәсіби мақсаттарыңызды анықтаңыз. Бұл лауазымдық көтерілу, жаңа дағдыларды үйрену немесе маңызды жобаларды сәтті аяқтау болуы мүмкін.",

        "textLabelLongGoals": "Ұзақ мерзімді мансаптық мақсаттар (3-5 жыл)",
        "textPlaceholderLongGoals": "Ұзақ мерзімде қандай бағытта дамығыңыз келеді. Болашақта өзіңізді қандай рөлдерде немесе лауазымдарда көресіз? Бұл мақсаттар мансаптық армандарыңызға жету үшін стратегиялық қадамдарға назар аударуға көмектеседі.",

        "textLabelUniqueTradeRelations": "Сіздің ерекше ұсынысыңыз (USP)",
        "textPlaceholderUniqueTradeRelations": "Сіздің салаңыздағы басқа мамандардан ерекшелендіретін не нәрсе? Бұл ерекше дағдылар, тәсілдер немесе жетістіктер болуы мүмкін.",

        "textLabelAchievements": "Марапаттар мен жетістіктер",
        "textPlaceholderAchievements": "Кәсіби марапаттар, сертификаттар немесе әріптестерден алған мақтаулар, бұл сіздің тәжірибеңіз бен саланың дамуына қосқан үлестеріңізді көрсетеді.",

        "textLabelProjects": "Аяқталмаған жобалар мен бастамалар",
        "textPlaceholderProjects": "Қазіргі уақытта жұмыс істеп жатқан жобалар немесе бастамалар туралы ақпарат, бұл аудиторияның қызығушылығын оятады.",

        "textLabelStrongSides": "Сіздің күшті жақтарыңыз",
        "textPlaceholderStrongSides": "Кәсіби іс-әрекетіңізді табысты орындауға және ерекшеленуге көмектесетін негізгі дағдылар мен қасиеттер.",

        "textLabelWeakSides": "Әлсіз жақтары",
        "textPlaceholderWeakSides": "Сіз жақсартуды қажет деп санайтын немесе дамытуға тырысатын аспектілер.",

        "selectLabelExperience": "Тәжірибе деңгейі",
        "selectPlaceholderExperience": "Тәжірибе деңгейіңізді таңдаңыз",

        "checkboxLabelThemes": "Талқылау тақырыптары",

        "checkboxLabelGoalsPublicLinkedIn": "Әлеуметтік желілерде жариялау мақсаттары"
    },
    "home": {
        "welcomeBack": "Қош келдіңіз, ",
        "logout": "Шығу",
        "logoutConfirm": "Сіз шынымен есептік жазбадан шыққыңыз келе ме?",
        "support": "Техникалық қолдау",
        "postsCalendar": "Жарияланымдар күнтізбесі",
        "guideline": "Пайдалы кеңестер",
        "homeNavTitle": "Басты бет",
        "contentPlanNavTitle": "Контент-план",
        "createPostNavTitle": "Быстрые публикации",
        "personalAssistantNavTitle": "Ассистент",
        "strategyNavTitle": "Стратегия",
        "contentPlan": "Контент жоспарын құру",
        "personalAssistant": "Жеке ассистент",
        "strategy": "Сандық стратегия",
        "moderation": "Модерация",
        "alertsManagement": "Ескертулерді басқару",
        "achievements": "Жетістіктер",
        "myAchievements": "Менің жетістіктерім",
        "createPost": "Пост жасау",
        "formatPost": "Пост форматы",
        "linkSocials": "Әлеуметтік желілерді байланыстыру",
        "profile": "Профиль",
        "personalBrandStrategy": "Жеке бренд — бұл мақсатты аудиторияның санасында қалыптасатын кәсіби қызметпен айналысатын адамның қоғамдық бейнесі.",
        "profileTitle": "Профиль, жазылым және шақырылған достар туралы ақпарат",
        "contentPlanTitle": "Бұл бөлімде болашақ посттар туралы ақпарат сақталады",
        "createPostTitle": "Мұнда сіз тез арада пост жасап, оны бірден жариялай аласыз.",
        "assistantTitle": "Диалог режимінде жеке ассистент мәтінді аудара алады, хаттар жаза алады және тағы басқалар.",
        "strategyTitle": "Мұнда сізге арналған стратегия жасалады.",
        "moderationTitle": "Мұнда сіз басқа пайдаланушылардың жазбаларын басқара аласыз",
        "role": "Амбассадор",
        "friend": "Дос",
        "welcome": "Қош келдіңіз",
        "useYourInnerVoice": "Ішкі дауысыңды пайдалан",
        "publicationCalendar": "Жариялау күнтізбесі",
        "publicationCalendarDesc": "Жарияланымдарды ыңғайлы күнтізбе арқылы жоспарлап, бақыла.",
        "instantPost": "Жедел пост",
        "instantPostDesc": "Тұрақты байланыс — кідіріссіз жариялау.",
        "contentPlanLong": "Контентті тиімді жоспарлап, жұмыс тәсілін өзгерт.",
        "personalAssistantDesc": "Деректерге негізделген шешім қабылдау үшін инсайттар ал.",
        "moderationDesc": "Коммуникацияны оңайлат және командалық жұмысты күшейт.",
        "analytics": "Аналитика",
        "analyticsDesc": "Икемді және сенімді инфрақұрылыммен оңай масштабтал.",
        "subscriptionDaysLeft": "Жазылым аяқталуына қалған күндер саны: {{days}}"
    },
    "personalBrand": {
        "needSurveyText": "Цифрлық контенты дәлірек жасау үшін сауалнамадан өту қажет",
        "coffee": "Бұл шамамен 5-7 минутты алады.\r\nСтратегия қалыптасып жатқанда, шабыттандыру үшін бір шыныаяқ кофе қалай болады?",
        "header": "Цифрлық стратегия",
        "newStrategy": "Жаңа бренд стратегиясын жасау",
        "Name": "Аты",
        "Occupation/Title": "Қызметі/Атауы",
        "Short Bio": "Қысқаша өмірбаяны",
        "Accolades & Awards": "Марапаттар мен жетістіктер",
        "Strengths": "Мықты жақтар",
        "Weaknesses": "Әлсіз жақтар",
        "Passions": "Қызығушылықтар",
        "Values": "Құндылықтар",
        "What Sets You Apart": "Сізді әріптестерден ерекшелендіретін нәрселер",
        "Unique Benefits You Can Provide": "Сіз ұсына алатын бірегей артықшылықтар",
        "Determine Who You are Trying to Reach and Communicate With": "Кімді қамтуды және байланысуды жоспарлайтыныңызды анықтаңыз",
        "Understand Their Needs, Wants, and Challenges": "Олардың қажеттіліктерін, қалауларын және қиындықтарын түсініңіз",
        "How Should Daniel Address These Needs and Challenges": "Бұл қажеттіліктер мен қиындықтарды {{username}} қалай шешуі керек?",
        "Colors": "Түстер",
        "Imagery": "Көрнекіліктер",
        "Personal Logo or Signature": "Жеке логотип немесе қолтаңба",
        "Areas of Expertise": "Маманданған салалар",
        "Content Formats": "Контент форматтары",
        "Content Themes": "Контент тақырыптары",
        "Engagement Strategy": "Қатысу стратегиясы",
        "Short-term Goals (1-2 years)": "Қысқа мерзімді мақсаттар (1-2 жыл)",
        "Long-term Goals (3-5 years)": "Ұзақ мерзімді мақсаттар (3-5 жыл)",
        "Feedback Channel": "Кері байланыс арнасы",
        "Adaptation Strategy": "Бейімделу стратегиясы",
        "Conclusion": "Қорытынды",
        "pdf": "PDF жүктеп алу"
    },
    "sendPassword": {
        "header": "Құпия сөзді ұмыттыңыз ба",
        "title": "Құпия сөзді өзгерту сілтемесін алу үшін электрондық пошта мекенжайыңызды енгізіңіз.",
        "placeholder": "Электрондық пошта мекенжайы",
        "sendCode": "Сілтеме жіберу",
        "return": "Артқа"
    },
    "newPassword": {
        "wrongEmail": "Жарамсыз электрондық пошта мекенжайы.",
        "noMatch": "Құпия сөздер сәйкес келмейді.",
        "header": "Жаңа құпия сөз жасау",
        "passwordRequirements": "Құпия сөзіңіз кемінде 8 таңбадан тұруы керек - 1 бас әріп, 1 кіші әріп, 1 сан және 1 арнайы таңба.",
        "placeholderCreate": "Жаңа құпия сөз жасау",
        "placeholderConfirm": "Құпия сөзді растау",
        "continue": "Жалғастыру"
    },
    "post": {
        "titlePage": "Пост Құрастыру",
        "improveBut": "Жақсарту",
        "saveBut": "Сақтау",
        "showMore": "көбірек",
        "rollUp": "айналдыру",
        "textToGenerateAnotherPost": "Осыған ұқсас немесе осы жазбаның жалғасын жазу",
        "at": "уақытында",
        "needSurveyText": "Цифрлық контенты дәлірек жасау үшін сауалнамадан өту қажет",
        "needSurveyRepeatText": "Келесі жазбаларды генерациялау үшін сізге сауалнаманы аяқтау қажет",
        "leadingQuestions": "Негізгі сұрақтар",
        "noLeading1": "Жеке жазба жазу үшін \"Генерациялау\" түймесін басыңыз",
        "noLeading2": "Егер қазір не туралы жазатыныңызды білмесеңіз, “Құру” батырмасын басыңыз – ұсынылған сұрақтар мен оларға барыншы мүмкін жауаптар Сізге бағыт беруі мүмкін. Әйтпесе, бұл ескертуді елемей-ақ қойыңыз.",
        "loading": "Жүктелуде...",
        "generate": "Генерациялау",
        "headerPost": "Жазба",
        "headerCreate": "Жазба жасау",
        "suggestion": "Жазба ұсынысы",
        "published": "Жарияланды",
        "notpublished": "Жарияланбаған",
        "broken": "Қате",
        "planned": "Жоспарланған",
        "hashtagSuggestion": "Хэштег ұсыныстары",
        "mediaSuggestion": "Визуал бойынша ұсыныстар",
        "image": "Медиа файлдар",
        "noImage": "Медиа файлдар жоқ!",
        "noImageInfoNotDrag": "Файлдарды осында апарыңыз немесе таңдау үшін басыңыз",
        "noImageInfoWithDrag": "Жүктеу үшін босатыңыз",
        "bigFileSize": "Файл тым үлкен. Басқа суретті таңдаңыз, ең көбі 10мб",
        "bigMediaListSize": "Медиа файлдардың жалпы салмағы {{size}}МБ-тан асады. Жалпы өлшемі {{size}}мб дейінгі басқа медиа файлдарды таңдаңыз",
        "maxVideoSize": "Файл тым үлкен. Басқа бейнені таңдаңыз, ең көбі 300мб",
        "uploadImage": "Сурет жүктеу",
        "processingImage": "Күтіңіз, біз суретті өңдеп жатырмыз",
        "save": "Сақтау",
        "generateImage": "Сурет жасау",
        "generatingImage": "Сурет жасалуда",
        "generating": "Біз сіздің жазбаңызды генерациялап жатырмыз",
        "remove": "Жою",
        "addVideo": "Бейне жүктеу",
        "removeVideo": "Бейнені жою",
        "removeImages": "Суреттерді жою",
        "removeSingleMediaConfirm": "Сіз бұл медиа файлды жойғыңыз келетініне сенімдісіз бе?",
        "removeAllMediaConfirm": "Сіз барлық медианы жойғыңыз келетініне сенімдісіз бе?",
        "maxVideoDuration": "Бейненің ұзақтығы тым үлкен. Ең көбі 10 минут болатын бейнені таңдаңыз",
        "dragActive": "Файлдарды осында апарыңыз немесе таңдау үшін басыңыз",
        "onDrag": "Жүктеу үшін босатыңыз",
        "dragInfo": "Сіз медиа файлдарды жүктей аласыз: ең көбі 200мб бейнелер және ұзақтығы 10 минутқа дейінгі бейнелер мен 8мб суреттер.",
        "notificationFilesForPlatformsTitle": "Әлеуметтік желілердегі суреттерге қатысты ұсыныстар",
        "notificationFilesForPlatformsDescription": "Әлеуметтік желілер әртүрлі суреттерге өз талаптарын қояды. Төменде әр платформаға арналған суреттерге қатысты ұсыныстар берілген:  \n" +
            " \n" +
            "LinkedIn\n" +
            "- Ұсынылатын өлшемі: 1200 x 627 пиксель (1.91:1 қатынасы).  \n" +
            "- Минималды өлшемі: 552 x 368 пиксель.  \n" +
            "- Максималды өлшемі: 7680 x 4320 пиксель.  \n" +
            " \n" +
            "Facebook\n" +
            "- Ұсынылатын өлшемі: 1200 x 630 пиксель.  \n" +
            "- Ұсынылатын ені: кемінде 630 пиксель.  \n" +
            " \n" +
            "Instagram\n" +
            "- Ұсынылатын өлшемі:1080 x 1080 пиксель.  \n" +
            "- Шаршы сурет: 1080 x 1080 пиксель(1:1).  \n" +
            "- Портрет: 1080 x 1350 пиксель (4:5).  \n" +
            "- Ландшафт: 1080 x 566 пиксель (1.91:1).  \n" +
            " \n" +
            "Маңызды:  \n" +
            "Әлеуметтік желілердегі жазбаларға, соның ішінде суреттерге қойылатын талаптар өзгеруі мүмкін. Сондықтан посттарды жариялау алдында олардың сәйкес келетінін тексеру ұсынылады.",
        "postGenerateImageLimit": "Бір постқа кескін генерациясының максималды саны-3 әрекет.",
        "postGenerateImageLeft": "Сізде әлі де әрекет бар:",
        "selectSocialsMedia": "Әлеуметтік медианы таңдаңыз",
        "apply": "Қолдану",
        "visibleLogoTitle": "Логотипті көрсету",
        "logoScales": {
            "SM": "Кішкентай",
            "MD": "Орташа",
            "LG": "Үлкен",
        },
        "logoPositions": {
            "TOP_LEFT": "Жоғарғы сол жақта",
            "TOP_RIGHT": "Жоғарғы оң жақта",
            "BOTTOM_LEFT": "Төменгі сол жақта",
            "BOTTOM_RIGHT": "Төменгі оң жақта",
            "LEFT": "Сол жақта",
            "RIGHT": "Оң жақта",
            "CENTER": "Ортасында",
            "TOP": "Жоғарғы жағында",
            "BOTTOM": "Төменде",
        },
        "videoToInstagramInfo": "Бейнелер тек Instagram-ға жүктеуге болады. Өтінеміз, Негізінен үйлесімді пішімін қолданыңыз.",
        "videoOrImagesOnly": "Reels тек бейнелерді қолдайды. Тек суреттерді немесе бейнелерді қосыңыз.",
    },
    "contentPlan": {
        "header": "Контент жоспары",
        "week": "Апта",
        "add": "Әлеуметтік желілерді таңдау үшін + басыңыз",
        "selectNetworks": "Әлеуметтік желілерді таңдаңыз",
        "frequency": "Жиілік",
        "elementsTitle": "Осы аптаның контенті үшін элементтерді таңдаңыз немесе қосыңыз",
        "custom": "Өзіңіздің сұрауларыңызды осында жазыңыз",
        "create": "Контент жоспарын жасау",
        "tokenError": "Генерациялау үшін кем дегенде бір әлеуметтік желі қосылған болуы керек",
        "strategyError": "Сіз жеке стратегия жасамадыңыз",
        "needSurveyText": "Контент жоспарын жасау үшін сауалнаманы аяқтау қажет",
        "goToSurveyBtnText": "Сауалнамаға өту",
        "selectWeekDaysTitle": "Аптаның қай күндеріне мазмұн жасау керектігін таңдаңыз",
        "brands": {
            "instagram": "Instagram",
            "linkedin": "LinkedIn",
            "facebook": "Facebook"
        },
        "readiness": "Дайындық күйі",
        "readyToPublish": "Жариялауға дайын",
        "notReadyHint": "Мазмұн жоспары дайын емес",
        "previewCompanyPage": "Компания парағы",
        "previewBusinessPage": "Бизнес парақшасы",
        "emptyAlt": "Бос контент жоспары",
        "languages": {
            "russian": "орыс тілінде",
            "english": "ағылшын тілінде"
        },
        "statusDraftSaved": "Жоба {{when}} сақталды",
        "autoSaveOn": "Автосақтау қосулы",
    },
    "organization": {
        "managedByOrganization": "Бұл профиль ұйыммен басқарылады",
        "viewFile": "Файлды қарау",
        "uploadFile": "Файлды жүктеу",
        "replaceFile": "Файлды ауыстыру",
        "replaceLogo": "Логотипті ауыстыру",
        "aboutOrganization": "Ұйым туралы",
        "contacts": "Байланыс",
        "name": "Аты",
        "establishmentYear": "Құрылған жылы",
        "email": "E-Mail",
        "phone": "Телефон",
        "website": "Веб-сайт",
        "address": "Мекенжай",
        "credentials": "Реквизиттер",
        "BANK": "БАНК",
        "BIC": "БИК",
        "BIN": "БИН",
        "IIK": "ИИК",
        "KBE": "КБЕ",
        "generalDirector": "Бас директор"
    },
    "postPage": {
        "cards": {
            "postTitle": "Жылдам пост",
            "platforms": "Платформалар",
            "linkAcc": "Қосу үшін тіркелгілерді",
            "schedule": "Кесте",
            "localTime": "Жергілікті уақытты пайдаланады",
            "whatPostSay": "Постта не айту керек?",
            "characters": "Символдар",
            "generationOptions": "Жасау опциялары",
            "formatPostTitle": "Формат",
            "languagesPost": "Тілдер",
            "lengthPost": "Ұзындығы",
            "emojisPost": "Эмодзилер",
            "modelPost": "Үлгі",
            "targetScheduleTitle": "Мақсатты желі және кесте",
            "when": "Қашан",
            "autoOptimizationTitle": "Авто-оңтайландыру",
            "postContentTitle": "Пост мәтіні",
            "hashtagsTitle": "Хэштегтер",
            "mediaSuggestionsTitle": "Медиа бойынша ұсыныстар",
            "mediaTitle": "Медиа",
            "mediaRequirementsTitle": "Медиа талаптары",
            "mediaRequirementsBody": "Сурет/видео форматтары және платформа шектеулері.",
            "bestTimeRecommendations": "Ең жақсы уақыт ұсыныстары",
            "autoRescheduleOnConflict": "Автоматты түрде қайта жоспарлау",
            "detailsTitle": "Жазбаларыңыз",
            "tipsTitle": "Кеңестер",
        },
        "toolbar": {
            "emojisOptions": {
                "none": "Жоқ",
                "few": "Аз",
                "more": "Көбірек",
            },
            "modelOptions": {
                "default": "Әдепкі",
                "creative": "Шығармашылық",
                "formal": "Ресми",
            },
        },
        "hint": {
            "hintText": "Қысқа, анық контекст сапаны жақсартады. Аудитория мен мақсатты қосыңыз.",
            "shortcutSend": "Жіберу: Ctrl+Enter",
            "shortcutPaste": "Қою: Ctrl+V",
            "previewHint": "Әлеуметтік желідегі жазбаңызды алдын ала қараңыз",
        },
        "brands": {
            "instagram": "Instagram",
            "linkedin": "LinkedIn",
            "facebook": "Facebook"
        },
        "buttons": {
            "copy": "Көшіру",
            "save": "Сақтау",
            "edit": "Өңдеу",
            "uploadImage": "Сурет жүктеу",
            "removeVideo": "Видеоны жою",
            "addVideoReels": "Видео қосу (Reels)",
            "generate": "Генерациялау",
            "removeImages": "Суреттерді жою",
            "saveFooter": "Сақтау",
            "publishFooter": "Жариялау",
            "clear": "Таза",
            "settings": "Параметрлер",
            "remember": "Есте сақта",
            "refresh": "Жаңарту",
            "hide": "Жасыру",
            "show": "Көрсету",
        },
        "placeholders": {
            "post": "Қызықты мәтін жазыңыз…",
            "hashtags": "#маркетинг #b2b #кейс",
            "media": "Визуалдар, тақырыптар немесе B-roll ұсыныңыз…",
            "addDetails": "Мәліметтер, негізгі нүктелер, сілтемелер қосу…",
            "detailsPlaceholder": "Мәтінмән, сілтемелер, нүктелер қосу…",
        },
        "dropzone": {
            "noImagesYet": "Әзірге суреттер жоқ",
            "dropFilesToUpload": "Жүктеу үшін файлдарды тастаңыз",
            "dragDropOrClick": "Жүктеу үшін сүйреп әкеліңіз немесе басыңыз",
            "hint": "PNG/JPG — әрқайсысы 8 МБ дейін, жалпы 80 МБ.",
            "browserNoVideoSupport": "Браузер video тегін қолдамайды.",
            "largeTotalWarning": "Медианың жалпы көлемі үлкен — сығуды қарастырыңыз.",
            "noLeadingYet": "Әзірге жетекші сұрақтар жоқ",
        },
        "footer": {
            "draftSaved": "Жоба бір минут бұрын сақталды • Автосақтау қосулы"
        },
        "misc": {
            "companyPage": "Компания парағы",
            "imageLabel": "Сурет"
        },
        "message": {
            "cannotEditPublished": "Жарияланған жазбаны өңдеу мүмкін емес",
        },
    },
    "functions": {
        "maxTextLength": "Таңбалардың максималды санына {{limit}} шегі асып кетті",
        "minTextLength": "Таңбалардың минималды саны {{limit}}",
        "noText": "Мәтін өрісі бос болуы мүмкін емес",
        "newPasswordFail": "Құпия сөзді өзгерту қатесі",
        "copiedFromService": "Қызметтен көшірілді",
        "noData": "Деректер жоқ",
        "apply": "Қолдану",
        "generate": "Құру",
        "generating": "Генерациялануда...",
        "successfullyGenerated": "Сәтті генерацияланды!",
        "successfullyFinished": "Сәтті аяқталды!",
        "successfullyUploaded": "Сәтті жүктелді!",
        "successfullySaved": "Сәтті қалды!",
        "successfullySendToGenerate": "Генерациялау процесі сәтті басталды!",
        "wrong": "Қате кетті",
        "loading": "Жүктелуде...",
        "sending": "Жіберілуде...",
        "microphone": "Микрофонға қол жеткізу қатесі, құрылғыны тексеріңіз немесе рұқсат беріңіз",
        "generatingPost": "Күтіңіз, пост генерациялануда",
        "generatingContentPlan": "Күтіңіз, контент жоспары генерациялануда",
        "generatingBrand": "Күтіңіз, стратегия генерациялануда",
        "loadingLeading": "Сұрақтар жүктелуде",
        "copied": "Көшірілді!",
        "changesSaved": "Өзгерістер сақталды!",
        "pastedFromClipboard": "Аралық сақтағыштан салынған!",
        "savingAnswersForStrategy": "Жауаптар сақталып, стратегия жасалуда",
        "close": "Жабу",
        "loggedIn": "Сәтті кірдіңіз!",
        "registered": "Сәтті тіркелдіңіз!",
        "incorrectCreds": "Кіру мүмкін болмады! Электрондық поштаңызды тексеруіңізді сұраймыз.",
        "limitReached": "Әрекет лимиті таусылды, {{count}} / {{max}} пайдаланылды",
        "recoveryRequested": "Пошта жәшігі дұрыс көрсетілсе, оған құпия сөзді қалпына келтіруге арналған сілтеме жіберілді.",
        "newPassword": "Құпия сөз жаңартылды",
        "error": "Қате",
        "errorPleaseCallSupport": "Қате, техникалық қолдауға хабарласыңыз.",
        "warning": "Ескерту",
        "wrongLayout": "Қате пернетақта орналасуы, тілді өзгерту қажет",
        "maxImages": "Максималды сурет саны - 6",
        "beta": "Бета",
        "minMediaForInstagramPostMessage": "Instagram-да жариялау үшін кем дегенде бір медиа файлды жүктеу немесе жасау керек!",
        "characterLimitError": "{{network}} символдардың максималды санын ({{limit}}) дейін шектейді",
        "pleaseEditPost": "Сіздің постыңыз символдар шектеуіне сәйкес болу үшін өңдеңіз.",
        "editPost": "Постты өңдеу",
        "collapse": "Орау",
        "expand": "Орналастыру",
        "next": "Келесі",
        "previous": "Артқа",
        "onThePage": "бетте",
        "copy": "Көшіру",
        "continue": "Жалғастыру",
        "accessAfterAuth": "Авторизациядан кейін ғана қол жетімді!",
        "successfullyMoved": "Сәтті жылжытылды!",
        "selectUser": "Пайдаланушыны таңдаңыз",
        "allUsers": "Барлық пайдаланушылар",
        "sortBy": "Сұрыптау түрі",
        "date": "Күні",
        "user": "Пайдаланушы",
        "ascending": "Өсу реті бойынша",
        "descending": "Кему реті бойынша",
        "filterByUser": "Пайдаланушы бойынша сүзгілеу",
        "generateDist": "Генерациялау",
        "name": "Аты",
        "reloadPageMessage": "Генерация күткеннен ұзағырақ болып жатыр. Сіз бетті қайта жаңарта аласыз.",
        "reloadPage": "Қайта жүктеу",
        "edit": "Редакциялау",
        "searchPosts": "Пост табу",
        "perImageTooLarge": "Әр сурет 8 МБ-тан аспауы керек",
        "totalImagesTooLarge": "Суреттердің жалпы көлемі 80 МБ-тан аспауы керек",
        "somethingWentWrong": "Бірдеңе дұрыс болмады",
        "pageSize": "Көрсету",
        "order": "Сұрыптау",
    },
    "socials": {
        "header": "Әлеуметтік желілер",
        "linkAccounts": "Авто-пост жасау үшін әлеуметтік желі есептік жазбаларын байланыстырыңыз"
    },
    "plancard": {
        "generated": "Пост генерацияланды",
        "notGenerated": "Пост генерацияланбады",
        "approved": "Бекітілген",
        "notApproved": "Бекітілмеген",
        "onModeration": "Модерацияда",
        "publish": "Постты жариялау",
        "approve": "Постты бекіту",
        "approveAgain": "Қайтадан жариялау",
        "disapprove": "Қайта қарауға жіберу",
        "cancel": "Жарияланудан бас тарту",
        "cantCancelPublished": "Жазба әлдеқашан жарияланған және оны кері қайтару мүмкін емес",
        "checkingPublish": "Жарияланым күйі тексерілуде…",
        "hide": "Жарияланымды жасыру",
        "hiddeConfrim": "Сіз бұл жазбаны шынымен жасырғыңыз келе ме?",
        "successfullyHidden": "Пост сәтті жасырылды!",
    },
    "posts": {
        "header": "Посттар",
        "generatePost": "Постты генерациялау",
        "postDescription": "Жоспарланған посттың негізгі идеясын немесе контекстін бөлісіңіз. Микрофонды пайдалануға болады.",
        "postDetails": "Мәліметтер",
        "settingsSaved": "Параметрлер сәтті сақталды",
        "postDate": "Жариялау күні",
        "publish": "Жариялау",
        "create": "Жасау",
        "cancel": "Бас тарту",
        "regenerate": "Постты қайта генерациялау",
        "limit": "Лимит таусылды. Қызметті жалғастыру үшін ақылы тарифке жазылуға болады.",
        "unknownError": "Қате пайда болды. Сізден сервисті техникалық қолдау бөліміне хабарласуыңызды және мәселені сипаттауыңызды сұраймыз. Мәселені тез шешу үшін бар күшімізді саламыз.",
        "notLinked-linkedin": "Посттарды жариялау үшін LinkedIn есептік жазбасын байланыстырыңыз",
        "notLinked-facebook": "Посттарды жариялау үшін Facebook есептік жазбасын байланыстырыңыз",
        "notLinked-instagram": "Посттарды жариялау үшін Instagram есептік жазбасын байланыстырыңыз",
        "notSelectedFacebookPage": "Facebook жазбаларын жариялау үшін профильдегі Facebook бетін таңдаңыз",
        "snErrorMessage": "Сіз жариялауға тырысып жатқан хабарлама әлеуметтік медианы байланыстыруды қажет етеді сізде жоқ немесе бас тартқан болуы мүмкін. Профильге өтіп, байланыстырыңыз әлеуметтік желілер осы жазбаны қолданатын және қайталап көріңіз.",
        "goToRate": "Тарифтерге өту",
        "goToProfile": "Профильге өту",
        "goToSupport": "Қолдауға өтіңіз",
        "chooseFormatTitle": "Жариялау форматын таңдаңыз",
        "acceptFormat": "Қабылдау",
        "formatExampleText": "Мысал",
        "createAnotherPost": "Ұқсас пост жасау",
        "seePost": "Постты көру",
        "formats": "Форматтар",
        "languages": "Тілдер",
        "selectLanguages": "Тілдерді таңдаңыз",
        "formatSettings": "Форматтау параметрлері",
        "formatPublication": "Публикация форматы",
        "noTextToFormat": "Форматтау үшін мәтін жоқ",
        "selectAtLeastOneLanguage": "Кем дегенде бір тілді таңдаңыз",
        "formatSuccess": "Мәтін сәтті пішімделді",
        "formatError": "Мәтінді пішімдеу қатесі",
        "postModelTitle": "Формат моделі",
        "modelBasic": "Негізгі",
        "modelAdvance": "Кеңейтілген",
        "selectedLanguages": "Таңдалған тілдер",
        "postLengthTitle": "Пост ұзындығы (сөздер)",
        "postEmojisTitle": "Посттағы эмодзилердің көптігі",
        "useEmojisTitle": "Эмодзилерді қолдану",
        "kazGenerateWarningMessage": "Қазір қазақ тіліндегі ұрпақ бета-тестілеуде, бірақ біз қазақ тіліндегі ұрпақ сапасын жақсарту үшін жұмыс істеп жатырмыз",
        "multiLanguagePostsGeneratePlaceholder": "Көп тілді жазбаларды жасау үшін Тілдерді таңдаңыз (бос қалдырылған жағдайда) пост профильде таңдалған тілде жасалады)",
        "multiLanguagePostsGenerateTitle": "Көп тілді посттарды құру",
        "multiLanguagePostsGenerateDescription": "Егер сіз бірнеше тілде хабарлама жасағыңыз келсе, төмендегі өрістегі тілдерді таңдаңыз. \n" +
            "Тілді таңдағанда, тілдерді таңдау тәртібін ескеріңіз (хабарлама тілдерді таңдау ретімен жасалады). \n" +
            "Егер сіз өрісті бос қалдырсаңыз, хабарлама профильде таңдалған тілде жасалады.",
        "postStatusesInfoTitle": "Жарияланымдардың мәртебесі туралы ақпарат",
        "postStatusModerated": "Промодерленген",
        "postsListEmptyText": "Жазбалар тізімі бос, пост жасау үшін \"пост жасау\" түймесін басыңыз",
        "postLanguageModelTitle": "Тіл моделін таңдау",
        "postModels": {
            "default": "Стандартты",
            "advance": "Жетілдірілген",
        },
        "memoizeChoice": "Таңдауды есте сақтаңыз",
        "noPostsTitle": "Әлі жазбалар жоқ",
        "noPostsHint": "Мұнда көру үшін бірінші жазбаңызды жасаңыз.",
    },
    "support": {
        "header": "Техникалық қолдау",
        "supportCardTitle": "Билет ашу",
        "sectionTitle": "Бөлім",
        "describeTitle": "Мәселені сипаттаңыз",
        "placeholderDescribe": "Не болды? Көбею қадамдары, күтілетін нәтиже, қоршаған орта…",
        "attachmentTitle": "Қосымшалар (суреттер немесе бейнелер)",
        "contactCard": {
            "title": "Байланыс",
            "hint": "Біз әдетте 1 жұмыс күні ішінде жауап береміз.",
        },
        "troubleShooting": {
            "title": "Ақаулықтарды жою",
            "hint": "Жаңа шығарылымнан кейін бірдеңе көрінбесе, офлайн кэшті тазалап, қолданбаны қайта жүктеп көріңіз.",
            "alert": {
                "title": "Кэштелген файлдарды тазалап, жаңартыңыз",
                "description": "Бұл кэштелген UI бумасын құрылғыңыздан жояды және бетті қайта жүктейді.",
                "buttonClear": "Кэшті тазалап, қайта жүктеңіз",
                "footerTip": "Кеңес: жылдамырақ ажыратымдылық үшін билетке скриншоттарды немесе қысқа экран жазбасын қосыңыз.",
            },
        },
        "sectionLabel": "Бөлімді таңдаңыз",
        "messageLabel": "Мәселені немесе ұсынысты сипаттаңыз",
        "fileLabel": "Файл тіркеу",
        "send": "Жіберу",
        "uploadFile": "Жүктелген файлдар",
        "removeFile": "Жою",
        "sections": {
            "home-page": "Басты бет",
            "profile-page": "Профиль",
            "content-plan": "Контент жоспары",
            "publication": "Жариялау",
            "personal-assistant": "Жеке көмекші",
            "personal-branding": "Жеке стратегия"
        },
        "dropzone": {
            "attachment": "Осы жерге сүйреп апарыңыз немесе жүктеп салу үшін басыңыз (6 файлға дейін)",
        },
        "buttons": {
            "chooseFiles": "Файлдарды таңдаңыз",
            "clear": "Таза",
            "send": "Жіберу",
            "remove": "Жою",
        },
        "clearCacheBtnTitle": "Кэшті тазарту",
        "clearCacheDescription": "Егер сізде ескірген деректермен проблемалар туындаса, ақпаратты жаңарту үшін \"Кэшті тазарту\" түймесін басыңыз.",
        "clearCacheSuccess": "Кэш сәтті тазартылды!",
        "ifQuestionGetSupport": "Егер сұрақтарыңыз немесе қиындықтарыңыз болса, <a class='text-primary' href='/support'>Қолдау</a> көрсету бөліміне хабарласыңыз.",
    },
    "moderation": {
        "header": "Модерация",
        "postsOnModerationEmpty": "Модерацияға арналған өзекті жазбалардың тізімі болсын!",
        "postsOnArchiveEmpty": "Мұрағат жазбаларының тізімі болсын!",
        "onModeration": "Модерацияда",
        "archive": "Мұрағат",
        "unreadModerationCountMessage": "Сізде {{count}} модерация жазбалары бар!",
        "goToModeration": "Модерацияға өтіңіз",
        "emptyModerationListTitle": "Модерацияға жазбалар жоқ",
        "emptyModerationListHint": "Тексеруді қажет ететін жаңа жазбалар осында пайда болады.",
        "emptyArchiveTitle": "Мұрағат бос",
        "emptyArchiveHint": "Мұрағатқа қабылданған немесе қабылданбаған жазбалар осында көрсетіледі.",
    },
    "hww": {
        "regTitle": "Қызметке тіркелу",
        "regSubtitle": "Қызметке тіркеліңіз",
        "strategyTitle": "Стратегия жасау",
        "strategySubtitle": "Сауалнамаға жауап беріңіз, және ЖИ жеке стратегия дайындайды",
        "planTitle": "Контент жоспарын жасау",
        "planSubtitle": "Стратегия негізінде ЖИ контент жоспарын ұсынады",
        "postTitle": "Посттарды жариялау",
        "postSubtitle": "Сіздің стратегияңыз бен контент жоспарыңыз негізінде ЖИ сізге пост идеяларын ұсынады"
    },
    "weekDays": {
        "Monday": "Дүйсенбі",
        "Tuesday": "Сейсенбі",
        "Wednesday": "Сәрсенбі",
        "Thursday": "Бейсенбі",
        "Friday": "Жұма",
        "Saturday": "Сенбі",
        "Sunday": "Жексенбі"
    },
    "months": {
        "January": "Қаңтар",
        "February": "Ақпан",
        "March": "Наурыз",
        "April": "Сәуір",
        "May": "Мамыр",
        "June": "Маусым",
        "July": "Шілде",
        "August": "Тамыз",
        "September": "Қыркүйек",
        "October": "Қазан",
        "November": "Қараша",
        "December": "Желтоқсан"
    },
    "alerts": {
        "createNotification": "Хабарландыру жасау",
        "editNotification": "Хабарландыруды өңдеу",
        "viewNotification": "Хабарландыруды қарау",
        "hintCreateAlerts": "Таңдалған қызметкерлер үшін ішкі ескертулер жасаңыз және жұмыстарды автоматты түрде жариялаңыз.",
        "history": "Тарих",
        "title": "Тақырып",
        "description": "Сипаттама",
        "type": "Түрі",
        "theme": "Тақырыбы",
        "link": "Сілтеме",
        "text": "Мәтін",
        "fromPostLink": "Постқа сілтеме",
        "postText": "Пост мәтіні",
        "status": "Күйі",
        "author": "Автор",
        "recipient": "Алушы",
        "createdAt": "Жасалған күні",
        "actions": "Әрекеттер",
        "create": "Жасау",
        "update": "Жаңарту",
        "cancel": "Болдырмау",
        "enterPostLink": "Постқа сілтеме енгізіңіз",
        "enterPostText": "Пост мәтінін енгізіңіз",
        "enterTitle": "Хабарлама тақырыбын енгізіңіз",
        "enterDescription": "Хабарлама сипаттамасын енгізіңіз",
        "selectType": "Хабарлама түрін таңдаңыз",
        "info": "Ақпарат",
        "warning": "Назар аударыңыз",
        "danger": "Маңызды",
        "selectTheme": "Хабарлама тақырыбын таңдаңыз",
        "alert": "Ескерту",
        "suggestion": "Ұсыныс",
        "createPost": "Пост құру",
        "titleRequired": "Тақырып міндетті",
        "descriptionRequired": "Сипаттама міндетті",
        "typeRequired": "Түрі міндетті",
        "themeRequired": "Тақырыбы міндетті",
        "employeesRequired": "Алушылардың тізімі міндетті",
        "createSuccess": "Хабарлама сәтті жасалды",
        "editSuccess": "Хабарлама сәтті жаңартылды",
        "fetchError": "Хабарламаларды алу кезінде қате",
        "success": "Сәтті",
        "error": "Қате",
        "createError": "Хабарламаны жасау кезінде қате",
        "editError": "Хабарламаны жаңарту кезінде қате",
        "yes": "Иә",
        "no": "Жоқ",
        "hideConfirmTitle": "Хабарламаны жасыру",
        "hideConfirmDescription": "Бұл хабарламаны пайдаланушылардан жасыруға сенімдісіз бе?",
        "hiddenSuccess": "Хабарлама сәтті жасырылды",
        "visibleSuccess": "Хабарлама пайдаланушыларға көрінеді",
        "postCreatedSuccess": "Пост сәтті жасалды!",
        "postCreatedForUsers": "{{employeeName}} қызметкеріне {{socialNetwork}} желісінде пост сәтті жасалды",
        "visibilityError": "Хабарламаның көрінуін өзгерту кезінде қате",
        "notVisibleTooltip": "Бұл хабарлама пайдаланушыларға көрінбейді",
        "viewNotificationTooltip": "Хабарлама мәліметтерін қарау",
        "employees": "Қызметкерлер",
        "newNotificationsCreated": "Жаңа хабарландырулар жасалды",
        "newNotificationsCreatedDesc": "Қосылған қызметкерлер үшін {{count}} жаңа хабарландыру жасалды",
        "noData": "Көрсетілетін деректер жоқ",
        "prompt": "Қосымша талап",
        "enterPrompt": "Қосымша талабыңызды енгізіңіз",
        "cardFormat": {
            "title": "Пішім параметрлері",
            "language": "Тіл:",
            "model": "Үлгі:",
            "length": "Ұзындығы:",
            "emojis": "Эмодзилерді қолданыңыз:",
        },
        "buttons": {
            "formattingOptions": "Пішімдеу опциялары",
            "selectAll": "Барлығын таңдау",
            "clear": "Тазалау",
        },
        "placeholder": {
            "title": "Қысқа тақырып енгізіңіз",
            "description": "Бұл хабарландыру не айту керек?",
            "theme": "Тақырыпты таңдаңыз",
            "selectEmployees": "Қызметкерлерді таңдаңыз",
            "prompt": "Қосымша: ұрпаққа арналған нұсқаулық",
            "link": "Мақалаға немесе бетке сілтеме қойыңыз",
            "sourceText": "Бастапқы мәтінді қойыңыз немесе жазыңыз (ең көбі 2000 таңба)",
            "employees": "Қызметкерлерді таңдаңыз",
            "language": "Тілдерді таңдаңыз",
        },
        "hint": {
            "title": "Тақырыпты енгізіңіз (2–200 таңба)",
            "description": "Сипаттаманы енгізіңіз (2–2000 таңба)",
            "theme": "Тақырыпты таңдаңыз",
            "employees": "Кем дегенде бір қызметкерді таңдаңыз",
        },
        "themeOption": {
            "alert": "Ескерту",
            "suggestion": "Ұсыныс",
            "createPost": "Пост жасау",
        },
        "cardPost": {
            "linkTitle": "Сілтемеден:",
            "sourceTextTitle": "Бастапқы мәтін:",
            "generatePost": "Жасалған пост:",
            "labelPrompt": "Промпт",
        },
    },
    "notifications": {
        "title": "Хабарландырулар",
        "open": "Хабарландыруларды ашу",
        "unread": "Оқылмаған хабарландырулар",
        "read": "Оқылған хабарландырулар",
        "empty": "Хабарландырулар жоқ",
        "allEmpty": "Көрсетілетін хабарландырулар жоқ",
        "markAsRead": "Оқылған деп белгілеу",
        "goToPost": "Постқа өту",
        "postCreationError": "Пост жасау кезінде қате",
        "employeeNoSocials": "{{employeeName}} үшін пост жасау мүмкін емес. Әлеуметтік желілердің кемінде біреуін байланыстыру керек.",
        "types": {
            "info": "Ақпарат",
            "warning": "Ескерту",
            "danger": "Маңызды"
        },
        "themes": {
            "alert": "Дабыл",
            "suggestion": "Ұсыныс",
            "create_post": "Жаңа хабарлама",
        },
        "yourHaveUnreadNotifications": "Сізде оқылмаған хабарландырулар бар ма"
    },
    "validation": {
        "enterName": "Толық атыңызды енгізіңіз",
        "nameValid": "Дұрыс енгізілді!",
        "nameRequired": "Толық атыңызды енгізіңіз",
        "enterEmail": "Электрондық поштаңызды енгізіңіз",
        "emailValid": "Электрондық пошта дұрыс енгізілген!",
        "emailInvalid": "Дұрыс электрондық поштаны енгізіңіз",
        "emailRequired": "Электрондық пошта міндетті",
        "emailDomainMustContainLetters": "Электрондық пошта домені әріптерден тұруы керек",
        "emailDomainExtensionTooShort": "Электрондық пошта домені тым қысқа",
        "emailDomainExtensionMustContainLetters": "Электрондық пошта доменінде әріптер болуы керек",
        "emailCannotContainConsecutiveDots": "Электрондық поштада қатарлас нүктелер болмауы керек",
        "enterPassword": "Құпия сөзіңізді енгізіңіз",
        "passwordValid": "Құпия сөз дұрыс енгізілді",
        "passwordInvalid": "Құпия сөз талаптарға сай емес",
        "passwordRequired": "Құпия сөз міндетті",
        "passwordTooShort": "Құпия сөз кемінде 8 таңбадан тұруы керек",
        "passwordTooLong": "Құпия сөз 128 таңбадан қысқа болуы керек",
        "passwordNeedsAnUppercase": "Құпия сөзде кемінде бір бас әріп болуы керек",
        "passwordNeedsALowercase": "Құпия сөзде кемінде бір кіші әріп болуы керек",
        "passwordNeedsANumber": "Құпия сөзде кемінде бір сан болуы керек",
        "passwordNeedsASpecialCharacter": "Құпия сөзде кемінде бір арнайы таңба болуы керек",
        "passwordCannotHaveSpaces": "Құпия сөзде бос орындар болмауы керек",
        "passwordIsTooCommon": "Құпия сөз тым қарапайым",
        "fixValid": "Пішін өрістерін тексеріңіз",
    },
    "achievements": {
        "goToMyAchievements": "Менің жетістіктеріме өту",
        "earnedLevel": "Сіздің ағымдағы деңгейіңіз",
        "earnedExperience": "Жинақталған тәжірибе",
        "earnedCoins": "Жинақталған тиындар",
        "unlockedCountAchievements": "{{count}} жетістіктен {{opened}} ашылды",
        "completedOnPercent": "{{percent}}% аяқталды",
        "completedOnCount": "{{count}} ішінен {{completed}} аяқталды",
        "benefits": "Артықшылықтар",
        "fetchingError": "Жетістіктер деректерін алу мүмкін болмады. Серверге қосылым қатесі, кейінірек қайталаңыз",

        "intern": {
            "title": "Стажер",
            "description": "Аккаунт құрылды — саяхатыңыз осыдан басталады!"
        },
        "activist": {
            "title": "Активист",
            "description": "Бір айда 10 жазба — сіз өз дауысыңызды табасыз!"
        },
        "inspirer": {
            "title": "Шабыттандырушы",
            "description": "20 жазба — сіздің үлесіңіз басқаларға шабыт береді!"
        },
        "ambassador": {
            "title": "Амбассадор",
            "description": "30 жазба — сіз қоғамдастықта танымал көшбасшысыз."
        },
        "ambassadorplus": {
            "title": "Амбассадор+",
            "description": "40 жазба және одан да көп — сіз нағыз оқиғаны қалыптастырып жатырсыз!"
        }
    },
    "achievementLevel": {
        "Intern": "Тәжірибеші ",
        "Activist": "Қоғам қайраткері",
        "Inspirer": "Шабыттандырушы",
        "Ambassador": "Амбассадор",
        "AmbassadorPlus": "Амбассадор +",
        "Description": {
            "Intern": "Қош келдіңіз! Сізбен бірге болғанымызға қуаныштымыз!",
            "Activist": "Сіздің ықпалыңыз айқындалуда!",
            "Inspirer": "Әлеуметтік желідегі ықпалдыңыз керемет деңгейде!",
            "Ambassador": "Сіз басқалардың көзқарастарын қалыптастырасыз",
            "Ambassadorplus": "Жоғары дәреже"
        }
    },
    "postDistribution": {
        "postDistributionForm": {
            "title": "Тақырып",
            "prompt": "Нұсқау",
            "languageLabel": "Тіл",
            "employees": {
                "employeesLabel": "Қызметкерлер",
                "placeholder": "Қызметкерлерді таңдаңыз",
                "selectAll": "Барлығын таңдаңыз",
                "clear": "Таза",
            },
            "placeholder": {
                "enterTitle": "Қысқа тақырып енгізіңіз",
                "enterPrompt": "Әрбір пост нені қамтуы керек? (тон, әрекетке шақыру, негізгі ойлар)",
                "chooseLanguage": "Тілдерді таңдаңыз",
            },
            "hint": {
                "title": "Тақырыпты енгізіңіз (2–200 таңба)",
                "prompt": "Сипаттаманы енгізіңіз (2–2000 таңба)",
                "language": "1–3 тілді таңдаңыз",
            },
            "linkTab": {
                "title": "Сілтеме",
                "label": "Бастапқы сілтеме",
                "placeholder": "Мақалаға немесе бетке сілтеме қойыңыз",
            },
            "textTab": {
                "title": "Мәтін",
                "label": "Бастапқы мәтін",
                "placeholder": "Бастапқы мәтінді қойыңыз немесе жазыңыз (ең көбі 8000 таңба)",
            },
        },
        "buttons": {
            "generating": "Жасалуда…",
            "generate": "Таңдалғандар үшін жасау",
        },
        "postDistributionTagName": "Посттарды тарату",
        "sendToRecipient": "Пайдаланушыға жіберу: ",
        "sendingInProgress": "Пост пайдаланушыға жіберілуде...",
        "postLanguages": "Генерация тілдері",
        "characterMinLimitError": "Пост мазмұны кемінде 25 таңба болуы керек",
        "characterMaxLimitError": "Пост мазмұны тым үлкен. Қазіргі таңбалар лимиті: ",
        "hashtagsRequired": "Хэштегтер міндетті",
        "fileSizeLimitExceeded": "Файлдың өлшемі тым үлкен.",
        "submissionSuccess": "Пост сәтті жіберілді!",
        "submissionFailure": "Постты жіберу сәтсіз аяқталды.",
        "regenerationSuccess": "Пост сәтті қайта генерацияланды!",
        "regenerationFailure": "Постты қайта генерациялау сәтсіз аяқталды!",
        "title": "Тақырып",
        "enterTitle": "Тақырыпты енгізіңіз",
        "promptInstruction": "Постты генерациялау нұсқауы",
        "enterDescription": "Сипаттаманы енгізіңіз",
        "link": "Сілтеме",
        "fromPostLink": "Пост сілтемесінен",
        "enterPostLink": "Пост сілтемесін енгізіңіз",
        "text": "Мәтін",
        "postText": "Пост мәтіні",
        "enterPostText": "Пост мәтінін енгізіңіз",
        "employees": "Қызметкерлер",
        "employeesRequired": "Кемінде бір қызметкерді таңдаңыз",
        "selectAll": "Барлығын таңдау",
        "clear": "Тазалау",
        "selectOneToThreeLanguages": "1-ден 3-ке дейін тіл таңдаңыз",
        "selectLanguages": "Тілдерді таңдаңыз",
        'regeneratePrompt': "Пост ұнамады ма? Не істеуіміз керек екенін айтыңыз!",
    },
    "postRegeneration": {
        "postRegenerationPlaceholder": "Өз талабыңызды осында жазыңыз – нәтижені сізге бейімдейміз. Немесе бос қалдырыңыз – біз жай ғана жазбаны қайта құрамыз."
    },
    "errors": {
        "notFound": "Ой! Мұнда көретін ештеңе жоқ",
    },
    "navigations": {
        "backHome": "Басты бетке оралу",
    },
    "analytics": {
        "menu": "Аналитика",
        "title": "Instagram аналитикасы",
        "noAccounts": "Қосылған Instagram бизнес аккаунттары жоқ.",
        "emptyLead": "Подписшылар, посттар және қатысу метрикаларын көру үшін бизнес Instagram аккаунтын қосыңыз.",
        "connectAccount": "Аккаунт қосу",
        "account": "Аккаунт",
        "filters": "Фильтрлер",
        "period": "Период",
        "days7": "7 күн",
        "days30": "30 күн",
        "followers": "Подписшылар",
        "followersTotalSub": "Барлығы",
        "media": "Посттар",
        "mediaTotalSub": "Жалпы посттар",
        "likesSum": "Лайктар (жиыны)",
        "commentsSum": "Пікірлер (жиыны)",
        "last10Posts": "Соңғы 10 пост үшін",
        "lastPostsAll": "Соңғы {{count}} біріктірілген пост үшін",
        "followersByDay": "Күндер бойынша подписшылар",
        "posts": "Посттар",
        "recentPosts": "Соңғы посттар",
        "recentPostsAll": "Соңғы посттар (барлық аккаунттар)",
        "date": "Күні",
        "post": "Пост",
        "likes": "Лайк",
        "comments": "Пікір",
        "link": "Сілтеме",
        "open": "Ашу",
        "noPosts": "Посттар жоқ",
        "refresh": "Жаңарту",
        "moderatorMode": "Модератор режимі",
        "allAccounts": "Барлық аккаунттар",
        "moderatorTag": "Модератор",
        "reach": "Қамту",
        "engagement": "Қатысқан аккаунттар",
        "profileViews": "Профиль қаралымдары",
        "metricFollowers": "Подписшылар",
        "metricPosts": "Посттар",
        "metricReach": "Қамту",
        "metricEngaged": "Қатысқан",
        "metricProfileViews": "Профиль қаралымдары",
        "metricSelector": "Метрика",
        "downloading": "Жүктелуде...",
        "downloadPdf": "PDF есепті жүктеу",
        "insights": "Insights"
    },
    "mediaInsights": {
        "title": "Медиа инсайттар",
        "periodWeek": "Соңғы 7 күн",
        "period30d": "Соңғы 30 күн",
        "back": "Артқа",
        "openPost": "Постты ашу",
        "rangeTitle": "Аралық",
        "likesByDay": "Күндер бойынша лайктар",
        "commentsByDay": "Күндер бойынша пікірлер",
        "metrics": {
            "comments": {"title": "Пікірлер", "description": "Посттағы пікірлер саны."},
            "follows": {"title": "Жазылулар", "description": "Аккаунтыңызға жаңа жазылулар саны."},
            "likes": {"title": "Лайктар", "description": "Посттағы лайктар саны."},
            "profile_activity": {"title": "Профиль әрекеттері", "description": "Осы контентпен әрекеттескен кезде профильде жасалған барлық әрекеттер жиыны."},
            "profile_visits": {"title": "Профиль қаралымдары", "description": "Профильге кіру саны."},
            "reach": {"title": "Қамтылған аккаунттар", "description": "Кем дегенде бір рет көрген бірегей аккаунттар саны (бағалау)."},
            "saved": {"title": "Сақтаулар", "description": "Постты сақтаулар саны."},
            "shares": {"title": "Бөлісулер", "description": "Постпен бөлісулер саны."},
            "total_interactions": {"title": "Әрекеттесулер", "description": "Лайктар, сақтаулар, бөлісулер және пікірлер минус жойылғандары."},
            "views": {"title": "Қаралымдар", "description": "Пост көрсетілімдері/ойнатылулары саны."}
        }
    }
}
